<h2 mat-dialog-title>
    {{ 'create_team' | translate}}
</h2>

<mat-dialog-content class="dialog-content-pad-10">

    <team-defaults-settings-form #teamDefaultForm [team]="data.team" mode="create" (onSubmit)="create()"></team-defaults-settings-form>

    <div class="row">
        <p class="alert alert-info col-md-6 mx-auto">
            <small><i class="far fa-info-square pe-1"></i> {{'create_team_modal.ps' | translate}}.</small>
        </p>
    </div>
        
</mat-dialog-content>

<mat-dialog-actions class="justify-content-center">
    <button type="button"
            class="btn btn-default"
            (click)="close()">{{'cancel' | translate}}</button>
    <button type="submit"
            class="btn btn-primary" 
            [disabled]="teamDefaultForm.form.invalid"
            (click)="create()">{{'create_team_modal.cta' | translate}}</button>
</mat-dialog-actions>